export default __webpack_public_path__ + "static/media/dark-bg-kahsh-labs.487393da.png";